import CertificateBackground from '@pngs/Certificate/CertificateBackground.png';
import ContentBackground from '@pngs/Certificate/ContentBackground.png';
import { theme } from '@styles';
import { ReactComponent as LogoEN } from '@svgs/logo_white_en.svg';
import { ReactComponent as LogoUA } from '@svgs/logo_white_ua.svg';

export const LogoIcon = {
  en: LogoEN,
  ua: LogoUA,
};

export const getTypographyStyle = ({ device, size, type }) => {
  if (device === 'mobile') {
    switch (type) {
      case 'title':
        return size === 'big' ? 'BN-regular-s92-lh78' : 'BN-bold-s64-lh55';
      case 'subtitle':
        return 'MS-semibold-s8-lh8';
      case 'name':
        return 'MS-bold-s16-lh17';
      case 'bold':
        return 'MS-bold-s8-lh8';
      case 'default':
        return 'MS-semibold-s8-lh8';
      default:
        return 'MS-semibold-s8-lh8';
    }
  }

  switch (type) {
    case 'title':
      return size === 'big' ? 'BN-regular-s92-lh78' : 'BN-bold-s64-lh55';
    case 'subtitle':
      return size === 'big' ? 'MS-semibold-s28-lh44' : 'MS-regular-s20-lh31';
    case 'name':
      return size === 'big' ? 'MS-bold-s57-lh60' : 'MS-bold-s40-lh42';
    case 'bold':
      return size === 'big' ? 'MS-bold-s26-lh40' : 'MS-bold-s20-lh31';
    case 'default':
      return size === 'big' ? 'MS-regular-s26-lh40' : 'MS-regular-s20-lh31';
    default:
      return 'MS-regular-s26-lh40';
  }
};

export const getLayoutProps =
  ({ device, size }) =>
  (type) => {
    const variant = getTypographyStyle({ device, size, type });

    if (device === 'mobile') {
      switch (type) {
        case 'subtitle':
          return {
            mt: '30px',
            variant,
          };
        case 'name':
          return {
            mt: '4px',
            variant,
          };
        case 'bold':
          return {
            my: '5px',
            variant,
          };
        case 'default':
          return {
            variant,
          };
        default:
          return {
            variant,
          };
      }
    }

    switch (type) {
      case 'title':
        return size === 'big' ? 'BN-regular-s92-lh78' : 'BN-bold-s64-lh55';
      case 'subtitle':
        return {
          mt: '112px',
          variant,
        };
      case 'name':
        return {
          mt: '14px',
          variant,
        };
      case 'bold':
        return {
          my: '20px',
          variant,
        };
      case 'default':
        return {
          variant,
        };
      default:
        return {
          variant,
        };
    }
  };

export const styles = {
  backgroundImage: {
    left: 0,
    position: 'relative',
    style: {
      background: `linear-gradient(341deg, rgba(105, 105, 105, 0.00) -24.27%, #C3C3C3 83.09%), 50% / cover no-repeat url(${ContentBackground}), #FFF`,
      mixBlendMode: 'overlay',
    },
    top: 0,
    width: '100%',
  },
  certificateContainer: {
    backgroundColor: '#D7D7D7',
    height: '100%',
    justifyContent: 'center',
    position: 'relative',
    style: {
      boxShadow: '0px 0px 28px 0px #353A33',
    },
    width: '100%',
  },
  container: {
    background: `url(${CertificateBackground})`,
    border: '4px solid #FD0',
  },
  contentContainer: {
    alignItems: 'center',
    border: '2px solid #182617',
    color: theme.colors.black[100],
    flexDirection: 'column',
    height: 'calc(100% - 12px)',
    left: 0,
    margin: '6px',
    position: 'absolute',
    style: {
      position: 'absolute',
    },
    top: 0,
    width: 'calc(100% - 12px)',
  },
};
